import { Heading, ListContainer, OrderTypeListItem } from '@altify/components';
import { useContent } from '@altify/utils';

import { useNavigate } from '@tanstack/react-router';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { createCallable } from 'react-call';
import { tradeSharedContent } from '../../tradeShared.content';
import { BuyNowIcon } from './Icons/BuyNowIcon';
import { RecurringBuyIcon } from './Icons/RecurringBuyIcon';
import { SellNowIcon } from './Icons/SellNowIcon';
import { content } from './OrderTypeModal.content';

export const OrderTypeModal = ({
  isOpen,
  productCode,
  onClose,
  filter,
}: {
  productCode?: string;
  isOpen: boolean;
  onClose: () => void;
  filter?: 'buy' | 'sell';
}) => {
  const navigate = useNavigate();
  const localizedContent = useContent(content, tradeSharedContent);
  const listItemColor = 'bg-[#1E2741]';

  const orderTypes = [
    {
      id: 1,
      className: listItemColor,
      iconComponent: BuyNowIcon,
      title: localizedContent.buyNow,
      subtitle: localizedContent.buyNowSubtitle,
      side: 'buy',
      onPress: () => {
        onClose?.();
        navigate({
          to: '/trade/buy-now',
          search: prev => ({ productCode: productCode ?? prev.productCode }),
        });
      },
    },
    {
      id: 2,
      className: listItemColor,
      iconComponent: RecurringBuyIcon,
      title: localizedContent.recurringBuy,
      subtitle: localizedContent.recurringBuySubtitle,
      side: 'buy',
      onPress: () => {
        onClose?.();
        navigate({
          to: '/trade/recurring-buy',
          search: prev => ({ productCode: productCode ?? prev.productCode }),
        });
      },
    },
    {
      id: 3,
      className: listItemColor,
      iconComponent: SellNowIcon,
      title: localizedContent.sellNow,
      subtitle: localizedContent.sellNowSubtitle,
      side: 'sell',
      onPress: () => {
        onClose?.();

        navigate({
          to: '/trade/sell-now',
          search: prev => ({ productCode: productCode ?? prev.productCode }),
        });
      },
    },
  ];

  const listItems =
    filter == null ? orderTypes : orderTypes.filter(o => o.side == filter);

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={onClose}
      backgroundColor="#0C1C2C">
      <div className="my-4 w-full flex flex-col items-center px-4">
        <Heading level={4} className="mb-6">
          {localizedContent.selectOrderType}
        </Heading>
        <ListContainer>
          {listItems.map(i => (
            <OrderTypeListItem {...i} key={i.id} />
          ))}
        </ListContainer>
      </div>
    </DialogOrBottomSheet>
  );
};

interface CallableProps {
  productCode: string;
  filter?: 'buy' | 'sell';
}

export const OrderTypeModalCallable = createCallable<CallableProps, boolean>(
  ({ call, filter, productCode }) => (
    <OrderTypeModal
      isOpen
      productCode={productCode}
      filter={filter}
      onClose={() => call.end(true)}
    />
  ),
);
